import { OpeningHoursType } from '@cnx-saas/common';
import { cnxIdTypeOptions } from '@cnx-saas/utils-cnx-id';
import { Location, LocationInput } from './Location';

export type LocationDocumentInput = LocationInput;
export type LocationDocument = Location; // Partial<Location>;

/**
 * Designates virtual load locations.
 *
 * Loads need to have a pick-up and drop-off address. If one of the addresses is
 * not known at the time the load is created, set both locations to the same
 * address, but set the location id of the unknown location to this id.
 */
export const nullLocationId = cnxIdTypeOptions.location.prefix!.padEnd(
  cnxIdTypeOptions.location.size,
  'NULL',
);

export function createNullLocationFromTemplate(template: Location): Location {
  const createdAt = new Date();
  return {
    id: nullLocationId,
    version: 1,
    createdAt,
    updatedAt: createdAt,
    tenantId: template.tenantId,
    address: {
      street: '-',
      city: '-',
      zipCode: '-',
      country: template.address.country,
      coordinates: template.address.coordinates,
    },
    owned: false,
    serviceTime: 0,
    openingHours: {
      openingHoursType: OpeningHoursType.UNKNOWN,
      openingHoursPerWeekDay: [],
      timezone: 'CET',
    },
  };
}
